function initMobileFilters( form: HTMLFormElement ): void {
    let count = 0;

    const filtersToIgnore = [
        'order',
        'author',
        'locationFreeText',
        'categoryFreeText',
        'categorySelection',
    ];

    const filters = form.querySelectorAll<HTMLInputElement | HTMLSelectElement>( 'input,select' );

    filters.forEach( function( el ) {
        if ( filtersToIgnore.includes( el.name ) ) {
            return;
        }

        if ( el.type === 'checkbox' && el.checked ) {
            count++;
            return;
        }

        if ( el.value && el.value.length > 0 ) {
            count++;
        }
    } );

    const counterElements = document.querySelectorAll<HTMLElement>( 'button[data-action="open-search-filters"] .counter' );

    if ( count === 0 ) {
        counterElements.forEach( function( counterElement ) {
            counterElement.classList.add( 'd-none' );
        } );
    } else {
        counterElements.forEach( function( counterElement ) {
            counterElement.innerHTML = count.toString();
        } );
    }
}

export default initMobileFilters;
